export function throwErrorOnServer(message: string) {
  if (message) {
    if (typeof window === 'undefined') {
      throw Error(message);
    } else {
      // eslint-disable-next-line no-console
      console.warn(message);
    }
  }
}

export function logOnServer(message: string) {
  if (process.env.isExport) return;
  if (message) {
    if (typeof window === 'undefined') {
      // eslint-disable-next-line no-console
      console.log(message);
    }
  }
}
